/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * 商品カード
 */
{
  const productCards = document.getElementsByClassName('js-productCard');
  window.addEventListener('DOMContentLoaded', function() {
    for (let i = 0; i < productCards.length; i++) {
      const productCard = productCards[i];
      const handle = productCard.dataset.handle;
      fetch(`/products/${handle}.js`)
        .then(response => response.json())
        .then(data => {
          const featuredImage = data.featured_image;
          const title = data.title;
          const url = data.url;
          const dom = `
            <div class="product-card__img-wrapper">
              <img src="${featuredImage}" class="product-card__img">
            </div>
            <div class="product-card__body">
              <p class="product-card__title">${title}</p>
              <div class="product-card__link-wrapper">
                <a href="${url}" class="Button Button--primary product-card__link">購入はコチラから</a>
              </div>
            </div>
          `;
          productCard.insertAdjacentHTML('beforeend', dom);
        })
        .catch(error => console.error('Error: ', error));
    }
  },);
}

/**
 * 商品詳細のカートに追加するボタンを強制発生させる
 */
{
  const addToCart = document.getElementById('js-AddToCart');
  const fakeAddToCartSm = document.getElementById('js-fakeAddToCartSm');

  if (fakeAddToCartSm) {
    fakeAddToCartSm.addEventListener('click', function() {
      const event = new Event('click', {"bubbles": true, "cancelable": false});
      addToCart.dispatchEvent(event);
    });

    const productSummary = document.getElementById('js-productSummary');
    if (productSummary) {
      let once = false;
      window.addEventListener('scroll', function () {
        // ターゲットの画面トップからの距離
        const position = productSummary.getBoundingClientRect().top;

        // 画面トップからの距離から画面の高さより小さければ実行する
        if (position <= window.innerHeight) {
          fakeAddToCartSm.classList.add('is-show');
        } else {
          if (fakeAddToCartSm.classList.contains('is-show')) {
            fakeAddToCartSm.classList.remove('is-show');
          }
        }
      });
    } else {
      fakeAddToCartSm.classList.add('is-show');
    }
  }
}

/**
 * 記事詳細ページにh2の目次を作成する
 */
{
  const tableContents = document.getElementById('js-tableContents');
  if (tableContents) {
    document.addEventListener('DOMContentLoaded', function() {
      const outlineDom = `
        <p class="table-contents__title">目次 ▼</p>
        <ul id="js-tableContentsList" class="table-contents__list">
        </ul>
      `
      tableContents.insertAdjacentHTML('beforeend', outlineDom);

      const articleBody = document.getElementById('js-articleBody');
      const h2 = articleBody.querySelectorAll('h2');
      const tableContentsList = document.getElementById('js-tableContentsList');
      h2.forEach((e, i) => {
        e.setAttribute('id', i);
        const dom = `
          <li class="table-contents__item"><a href="#${i}">${e.innerText}</a></li>
        `
        tableContentsList.insertAdjacentHTML('beforeend', dom);
      });

    }, false);
  }
}

jQuery(function($) {
  const SCROLL_SPEED = 300;
  const HEADER = $('#section-header');
  const DRAWER = $('.js-drawer');
  const BREAK_POINT_MAX = '(max-width: 768px)';
  {
    $('a[href^="#"]').click(function() {
      var href= $(this).attr("href");
      var hash = href == "#" || href == "" ? 'html' : href;
      scrollToAnchor(hash);
      return false;
    });

    $(document).ready(function(){
      var hash = location.hash;
      if(hash) {
        $('html, body').stop().scrollTop(0);
        setTimeout(function () {
          scrollToAnchor(hash);
        }, 100);
      }
    });

    function scrollToAnchor(hash) {
      var target = HEADER;
      // if (window.matchMedia(BREAK_POINT_MAX).matches) {
      // } else {
      //   var target = HEADER;
      // }
      var targetHeight = target.outerHeight();
      var barHeight = $('.ArticleToolbar').outerHeight();
      var pos = $(hash).offset().top - targetHeight - barHeight;
      $('html, body').stop().animate({scrollTop: pos}, SCROLL_SPEED);
    }
  }
});

